import React, { useEffect, useState, useCallback } from 'react'
import { Table, Modal } from 'antd'
import { CardContainer, IconTrash, Text } from '@tutorbot/ui-components'
import { getNewClients, deleteToken } from '../../services/api/ums/client'
import moment from 'moment'
import qs from 'qs'
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../services/tableSort'
import NoDataAvailable from '../UI/NoDataAvailable/NoDataAvailable'
import { tokenDeleteConfirmation } from '../UI/Modal/ModalContent'
import { useSelector } from 'react-redux'
import styles from './ClientList.module.css'

const ClientList = () => {
  const [clientsData, setClientsData] = useState([])
  const [tokenId, setTokenId] = useState(null)
  const [loading, setLoading] = useState(false)
  const lastUpdatedAt = useSelector((state) => state.clientLastUpdatedAtEvent.listLastUpdatedAt)

  const getQueryString = useCallback(() => {
    const q = {
      _sort: 'created_at:desc'
    }
    return qs.stringify(q)
  })

  const getClientsDataList = useCallback(() => {
    const filter = getQueryString()
    setLoading(true)
    getNewClients(filter)
      .then((res) => {
        if (res && res.data) {
          setClientsData(res.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [getQueryString])

  useEffect(() => {
    getClientsDataList()
  }, [lastUpdatedAt])

  const renderCreatedAt = (value) => (
    <Text rows={1} level={2}>{moment(value).format('DD-MM-YY HH:mm:ss')}</Text>
  )

  const renderDelete = (value) => (
    <span className={styles.delete_icon}>
      <IconTrash onClick={() => tokenDeleteHandler(tokenId)} />
    </span>
  )

  const tokenDeleteHandler = () => {
    tokenDeleteConfirmation(handleTokenDelete)
  }

  const handleTokenDelete = () => {
    deleteToken(tokenId)
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        Modal.destroyAll()
        getClientsDataList()
      })
  }

  const renderText = (value) => <Text rows={1} level={2}>{value}</Text>

  const columns = [
    { title: 'Name', dataIndex: 'name', align: 'left', render: renderText },
    { title: 'Token', dataIndex: 'token', render: renderText },
    { title: 'Created at', dataIndex: 'created_at', render: renderCreatedAt },
    { title: '', dataIndex: '', align: 'end', render: renderDelete }
  ]

  const onRowClick = (record) => {
    return {
      onMouseEnter: () => {
        setTokenId(record.id)
      }
    }
  }

  return (
    <div className={styles.add_client_container}>
      <CardContainer>
        <div className={styles.list_top}>
          <h1 className={styles.title}>Clients</h1>
        </div>
        <Table
          rowKey={record => record.api_key_id}
          onRow={onRowClick}
          columns={columns}
          dataSource={clientsData}
          className={styles.table}
          loading={loading}
          sticky
          size='small'
          locale={{ emptyText: <NoDataAvailable /> }}
          pagination={{
            defaultPageSize: DEFAULT_PAGE_SIZE,
            pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
            showLessItems: true
          }}
        />
      </CardContainer>
    </div>
  )
}

export default ClientList
